import { Star } from "lucide-react";
import { testimonials } from "@/data/content";

export const Testimonials = () => {
  return (
    <section id="kokemukset" className="py-16 sm:py-24 bg-[#FDFBF7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-base font-bold text-[#245037] uppercase tracking-wide">
            Kokemuksia
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#1C1917]">
            Asiakkaat kertovat
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-2xl p-8 shadow-sm border border-[#E8E2D5] flex flex-col"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-5 h-5 fill-[#E8C88A] text-[#E8C88A]" />
                ))}
              </div>
              <p className="text-lg leading-relaxed text-[#44403C] italic flex-1">"{t.text}"</p>
              <div className="mt-6 pt-4 border-t border-[#E8E2D5]">
                <p className="font-bold text-[#1C1917]">{t.name}</p>
                <p className="text-base text-[#78716C]">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
